<template>
  <div class="content-wrapper">
    <b-card class="col-md-12 no-padding"  :header="$t('Create Company with New License')" header-bg-variant="light" header-text-variant="white" >
      <b-form @reset="onReset" v-if="show">
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <div class="col-md-6 float-left">
          <label class="col-12 no-padding pb-2">{{$t('Company Details')}}</label>
          <b-form-group :label="$t('Company Name')" label-for="input-123">
            <b-form-input
              id="input-123"
              v-model="form.name"
              required
              :placeholder="$t('Company Name')"
              :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group :label="$t('VAT Number')" label-for="input-223">
            <b-form-input
              id="input-223"
              v-model="form.vat"
              placeholder="VAT Number"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;" :label="$t('Telephone')" label-for="input-35" >
            <b-form-input
              type="tel"
              id="input-35"
              autocomplete="__away"
              v-model="form.phoneNumber"
              placeholder="Telephone"
            ></b-form-input>
            <b-form-invalid-feedback id="input-6-live-feedback">
             {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group style="width: 50%;float:left;padding-left: 5px" :label="$t('2nd Telephone:')" label-for="input-55" >
            <b-form-input
              type="tel"
              id="input-55"
              v-model="form.secondPhoneNumber"
              :placeholder="$t('Telephone')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-6-live-feedback">
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;"  :label="$t('Address')" label-for="input-323">
            <b-form-input
              id="input-323"
              v-model="form.address"
              :placeholder="$t('Address')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px"  :label="$t('Postcode')" label-for="input-423">
            <b-form-input
              id="input-423"
              v-model="form.postcode"
              :placeholder="$t('Postcode')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;" :label="$t('Number of Manager Licenses:')" label-for="input-15">
            <b-form-input
              type="number"
              id="input-15"
              v-model="form.numberOfManagerLicenses"
              :state="$v.form.numberOfManagerLicenses.$dirty ? !$v.form.numberOfManagerLicenses.$error : null"
              :placeholder="$t('Licences Number')"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px"
                        :label="$t('Expiry Date')"
                        label-for="name-input23"
                        description="."
          >
            <b-form-input
              id="name-input23"
              type="date"
              v-model="form.managerExpiryDate"
              :state="$v.form.managerExpiryDate.$dirty ? !$v.form.managerExpiryDate.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input0-5-live-feedback">
              {{$t('This is a required field')}}.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group style="width: 50%;float:left;" :label="$t('Number of Supervisor Licenses:')" label-for="input-2555">
            <b-form-input
              type="number"
              id="input-2555"
              v-model="form.numberOfSupervisorLicenses"
              required
              :state="$v.form.numberOfSupervisorLicenses.$dirty ? !$v.form.numberOfSupervisorLicenses.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group style="width: 50%;float:left;padding-left: 5px"
                        :label="$t('Expiry Date')"
                        label-for="name-input-9"
                        description="."
          >
            <b-form-input
              id="name-input-9"
              type="date"
              v-model="form.supervisorExpiryDate"
              :state="$v.form.supervisorExpiryDate.$dirty ? !$v.form.supervisorExpiryDate.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              {{$t('This is a required field')}}.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group style="width: 50%;float:left;" id="input-group-2" :label="$t('Number of User Licenses:')" label-for="input-25">
            <b-form-input
              type="number"
              id="input-25"
              v-model="form.numberOfLicenses"
              required
              :state="$v.form.numberOfLicenses.$dirty ? !$v.form.numberOfLicenses.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{$t('This is a required field.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px"
            :label="$t('Expiry Date')"
            label-for="name-input"
                        description="."
          >
            <b-form-input
              id="name-input"
              type="date"
              v-model="form.expiryDate"
              :state="$v.form.expiryDate.$dirty ? !$v.form.expiryDate.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              {{$t('This is a required field')}}.
            </b-form-invalid-feedback>
          </b-form-group>

        <b-form-group style="width: 100%" id="input-group-4" :label="$t('Status')" label-for="input-4">
          <b-form-select
            id="input-4"
            size="sm"
            v-model="form.status"
            :options="statuses"
            :state="$v.form.status.$dirty ? !$v.form.status.$error : null"
          ></b-form-select>
          <b-form-invalid-feedback id="input-7-live-feedback">
           {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        </div>
        <div class="col-md-6 float-left" style="background: #f7fafb;">
          <label class="col-12 no-padding pb-2">{{$t('Administrator Details')}}</label>

          <b-form-group style="width: 50%;float:left;"  :label="$t('First Name:')" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.firstName"
              :state="$v.form.firstName.$dirty ? !$v.form.firstName.$error : null"
              required
              placeholder="First Name"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-6" :label="$t('Last Name:')" label-for="input-22">
            <b-form-input
              id="input-22"
              v-model="form.lastName"
              :state="$v.form.lastName.$dirty ? !$v.form.lastName.$error : null"
              required
              placeholder="Last Name"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            :label="$t('Email address')"
            label-for="input-12"
            :description="$t('The email address must be unique for every user.')"
          >
            <b-form-input
              id="input-12"
              v-model="form.email"
              type="email"
              required
              :placeholder="$t('Enter email')"
              :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-3-live-feedback">
              {{$t('Email address is required and must be properly formatted.')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            :label="$t('Password:')"
            label-for="input-13333"
            :description="$t('Select a password for the Administrator.')"
          >
            <b-form-input
              id="input-13333"
              autocomplete="__away"
              v-model="form.password"
              type="password"
              required
              :placeholder="$t('Enter Password')"
              :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-4-live-feedback">
              {{$t('Email address is required and must be properly formatted.')}}
            </b-form-invalid-feedback>
          </b-form-group>

        </div>
        <div class="col-12 float-left pt-3">
          <b-button @click="onSubmit" variant="light" class="text-white">{{$t('Submit')}}</b-button>
          <b-button type="reset" variant="secondary">{{$t('Reset')}}</b-button>
        </div>
      </b-form>

    </b-card>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
  name: 'CompanyForm',
  data () {
    return {
      loading: false,
      licenses: [],
      form: {
        secondPhoneNumber: null,
        postcode: null,
        address: null,
        phoneNumber: null,
        vat: null,
        numberOfLicenses: null,
        expiryDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        numberOfManagerLicenses: null,
        managerExpiryDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        supervisorExpiryDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        numberOfSupervisorLicenses: null,
        name: null,
        email: '',
        license: null,
        password: '',
        firstName: '',
        lastName: '',
        role: 'Administrator',
        status: 'Active'
      },
      roles: [{ text: 'Select Role', value: null }, 'Super Admin', 'Administrator'],
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}],
      show: true
    }
  },
  validations: {
    form: {
      lastName: {
        required,
        minLength: minLength(3)
      },
      firstName: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      name: {
        required
      },
      numberOfLicenses: {
        required
      },
      status: {
        required
      },
      expiryDate: {
        required
      },
      supervisorExpiryDate: {
        required
      },
      managerExpiryDate: {
        required
      },
      numberOfSupervisorLicenses: {
        required
      },
      numberOfManagerLicenses: {
        required
      }
    }
  },
  mounted () {
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let self = this
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      self.loading = true
      if (this.form.role === 'Administrator') {
        const createUser = this.$firebase.functions().httpsCallable('createUser')
        createUser(this.form).then(function (result) {
          // success or error handling
          if (result.data.errorInfo) {
            self.error = true
            self.errorMessage = result.data.errorInfo.message
            self.$swal({
              title: self.$t('There was an error!'),
              text: result.data.errorInfo.message,
              type: 'error',
              timer: 0,
              showConfirmButton: true
            })
          } else {
            self.$store.dispatch('fetchCompanies')
            self.$swal({
              title: self.$t('Company Created!'),
              text: self.$t('The Administrator can now use the Panel!'),
              type: 'success',
              timer: 3000,
              showConfirmButton: false
            }).then(function (result) {
              self.$router.push({name: 'Companies'})
            })
          }
          self.loading = false
        })
      } else {
        // this.createUser()
      }
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.password = null
      this.form.status = 'Active'
      this.form.name = ''
      this.form.numberOfLicenses = null
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$v.$reset()
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CompanyForm.vue